module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray@2x-c54b88024c5c0910062a74ff88a8be05.png";